import { createCRUDHook } from './createCRUDHook';
import { TBL_CUSTOMER_ORDER_BOXES } from './apiEndPoints';
import { DimensionAndWeightDto } from 'utils/models';

const { Context, useManager, useConsumer } =
  createCRUDHook<DimensionAndWeightDto>({
    entityName: 'CustomerOrderBoxes',
    endpoint: TBL_CUSTOMER_ORDER_BOXES,
  });

export const CustomerOrderBoxContext = Context;
export const useCustomerOrderBoxManager = useManager;
export const useCustomerOrderBox = useConsumer;
